module.exports = __webpack_public_path__ + "img/92.944e06cf.jpg";